/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品契約
 */
export interface Szma103aResFtiGoodsDto {
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 付帯契約書番号：英数字
     */
    futaicontractdocumntNo?: string;
    /**
     * 継続年数：数字
     */
    duration?: number;
    /**
     * 満了予定年月：日付(yyyyMM)
     */
    expireScheduleyearmonth?: string;
    /**
     * 付帯契約開始日
     */
    futaiCtrStartdate?: string;
}

